import { Payment } from '@zooplus/payment-frontend';

const PaymentComponent = () => {
  return <Payment />;
};

export default PaymentComponent;
